<template>
    <section
        id="hero"
        class="section hero-section section-banner inner-page bg-banner bg-cover light-text"
    >
        <div class="inner">
            <div class="hero-bottom">
                <div class="hero-container">
                    <div class="inner">
                        <div class="row">
                            <div class="col-md-8 alpha">
                                <h2 class="tagline">
                                    <p
                                        v-html="
                                            conferenceTextData.conference_title_banner
                                        "
                                    ></p>
                                    <span
                                        class="sub-head"
                                        v-html="
                                            conferenceTextData.conference_dates_banner
                                        "
                                    ></span>
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "Header",
    computed: {
        ...mapGetters(["conferenceTextData"])
    },
};
</script>

<style scoped>
.tagline {
    min-height: 3em;
}
@media print {
    .non-printable {
        display: none;
    }
}
</style>
